<template>
  <v-container fluid>
    <!-- KPIs Dashboard -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #4CAF50' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Total Productos</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ kpiData.total_products || 0 }}
            </div>
            <div class="text-caption grey--text">
              En {{ kpiData.total_categories || 0 }} categorías
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #2196F3' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Valor Total</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(kpiData.total_value || 0) }}
            </div>
            <div class="text-caption grey--text">
              Precio promedio: {{ formatCurrency(kpiData.average_price || 0) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #FF9800' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Total Unidades</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ kpiData.total_units || 0 }}
            </div>
            <div class="text-caption grey--text">
              Promedio por producto: {{ kpiData.average_units || 0 }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #9C27B0' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Con Descuento</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ kpiData.discounted_products || 0 }}
            </div>
            <div class="text-caption grey--text">
              {{ kpiData.discount_percentage || 0 }}% del inventario
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6" elevation="2">
      <v-card-title class="primary white--text py-3 px-4">
        <v-icon color="white" class="mr-2">mdi-filter</v-icon>
        <span>Filtros</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Búsqueda general"
          single-line
          hide-details
          class="mx-2"
          dark
          dense
          style="max-width: 300px"
        ></v-text-field>
        <v-btn
          small
          text
          icon
          color="white"
          @click.stop="showFilterPanel = !showFilterPanel"
        >
          <v-icon>{{ showFilterPanel ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-expand-transition>
        <div v-if="showFilterPanel">
          <v-card-text class="py-4">
            <v-row>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="filters.nombre"
                  label="Nombre del producto"
                  prepend-icon="mdi-tag-text"
                  clearable
                  outlined
                  dense
                  @input="filterData"
                  hide-details
                />
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-select
                  v-model="filters.categoria"
                  :items="categories"
                  label="Categoría"
                  prepend-icon="mdi-shape"
                  item-value="valor"
                  item-text="valor"
                  outlined
                  dense
                  clearable
                  @change="filterData"
                  hide-details
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-autocomplete
                  v-model="filters.marca"
                  :items="brands"
                  label="Marca"
                  prepend-icon="mdi-tag"
                  item-value="valor"
                  item-text="valor"
                  outlined
                  dense
                  clearable
                  @change="filterData"
                  hide-details
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="filters.refe"
                  label="Referencia"
                  prepend-icon="mdi-barcode"
                  clearable
                  outlined
                  dense
                  @input="filterData"
                  hide-details
                />
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="filters.precio"
                  label="Precio"
                  prepend-icon="mdi-currency-usd"
                  type="number"
                  clearable
                  outlined
                  dense
                  @input="filterData"
                  hide-details
                />
              </v-col>

              <!-- Nuevos filtros -->
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-select
                  v-model="filters.grupo"
                  :items="grupos"
                  label="Grupo"
                  prepend-icon="mdi-folder"
                  item-value="valor"
                  item-text="valor"
                  outlined
                  dense
                  clearable
                  @change="filterData"
                  hide-details
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-select
                  v-model="filters.color"
                  :items="colors"
                  label="Color"
                  prepend-icon="mdi-palette"
                  item-value="valor"
                  item-text="valor"
                  outlined
                  dense
                  clearable
                  @change="filterData"
                  hide-details
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-select
                  v-model="filters.talla"
                  :items="tallas"
                  label="Talla"
                  prepend-icon="mdi-ruler"
                  outlined
                  dense
                  clearable
                  @change="filterData"
                  hide-details
                ></v-select>
              </v-col>
            </v-row>

            <v-row class="mt-4">
              <v-col cols="12" class="text-right">
                <v-btn color="grey" text @click="resetFilters" class="mr-2">
                  <v-icon left>mdi-refresh</v-icon>
                  Limpiar filtros
                </v-btn>
                <v-btn color="primary" @click="filterData">
                  <v-icon left>mdi-filter</v-icon>
                  Aplicar filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
    <v-data-table
      show-select
      v-model="selected"
      :headers="headers"
      :items="inventory_filter"
      :items-per-page="10"
      item-key="ean"
      :loading="loading_status"
      loader-height="10"
      loading-text="Cargando ..."
      :search="search"
      dense
    >
      <template #top>
        <v-card class="mb-6" elevation="2">
          <v-app-bar flat dense color="secondary" dark>
            <v-toolbar-title>Inventario</v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- Contador de selección -->
            <v-chip v-if="selected.length" small class="mr-3">
              {{ selected.length }} items seleccionados
            </v-chip>

            <!-- Botón de opciones -->
            <v-menu offset-y left :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="white" text v-bind="attrs" v-on="on">
                  <span class="mr-2">Opciones</span>
                  <v-icon>mdi-cog</v-icon>
                </v-btn>
              </template>

              <v-card min-width="300">
                <v-list dense>
                  <!-- Grupo de Etiquetas -->
                  <v-subheader>Etiquetas</v-subheader>
                  <v-list-item @click="printLabels" :disabled="!selected.length">
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-printer</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Imprimir etiquetas</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="selected.length">
                      <v-chip x-small>{{ selected.length }}</v-chip>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider></v-divider>

                  <!-- Grupo de Precios -->
                  <v-subheader>Precios</v-subheader>
                  <v-list-item
                    @click="edit_price = !edit_price"
                    :disabled="!selected.length"
                  >
                    <v-list-item-icon>
                      <v-icon color="success">mdi-currency-usd</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Cambio de precio</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="selected.length">
                      <v-chip x-small>{{ selected.length }}</v-chip>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item
                    @click="edit_discount = !edit_discount"
                    :disabled="!selected.length"
                  >
                    <v-list-item-icon>
                      <v-icon color="success">mdi-sale</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Aplicar descuento</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="selected.length">
                      <v-chip x-small>{{ selected.length }}</v-chip>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider></v-divider>

                  <!-- Grupo de Reportes -->
                  <v-subheader>Reportes</v-subheader>
                  <v-list-item @click="price_changes_lst = !price_changes_lst">
                    <v-list-item-icon>
                      <v-icon color="info">mdi-history</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Cambios de precio</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="exportJSONToCSV(inventory_filter)">
                    <v-list-item-icon>
                      <v-icon color="info">mdi-microsoft-excel</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Exportar a Excel</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider></v-divider>

                  <!-- Grupo de Selección -->
                  <v-subheader>Selección</v-subheader>
                  <v-list-item @click="selectAll">
                    <v-list-item-icon>
                      <v-icon color="warning">mdi-select-all</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Seleccionar todo</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="clearSelection" :disabled="!selected.length">
                    <v-list-item-icon>
                      <v-icon color="warning">mdi-select-off</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Limpiar selección</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-app-bar>
        </v-card>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-magnify </v-icon>
      </template>
    </v-data-table>

    <template>
      <v-dialog v-model="item_dialogo" max-width="600px">
        <v-card>
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-card flat>
                <v-img
                  cover
                  aspect-ratio="1"
                  class="grey lighten-2"
                  :src="getImageURL(itemEdit.marca, itemEdit.refe)"
                  max-height="300"
                >
                </v-img>
                <input
                  class="file-input"
                  ref="fileInput"
                  type="file"
                  @input="onSelectFile(itemEdit)"
                />
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute color="#036358">
                    <v-btn @click="chooseImage">Upload</v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </template>
          </v-hover>
        </v-card>
      </v-dialog>
    </template>

    <v-dialog v-model="edit_price" max-width="400px">
      <v-form v-model="price_valid" ref="priceChangeform" @submit="price_change">
        <v-card>
          <v-toolbar dark color="secondary" flat dense>
            <h3>Cambio de precio</h3>
            <v-spacer></v-spacer>
            <v-btn x-small fab color="orange" @click="edit_price = !edit_price">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-6" v-if="selected.length === 0">
            <h5>Debe seleccionar los productos a los que quiere cambiar el precio</h5>
          </v-card-text>
          <v-card-text class="pt-6" v-if="selected.length !== 0">
            <h3>El nuevo precio será aplicado a {{ selected.length }} productos.</h3>
          </v-card-text>
          <v-card-text>
            <v-text-field
              mt="6"
              v-model="newPrice"
              class="centered-input"
              label="Nuevo precio"
              solo
              prepend-inner-icon="mdi-currency-usd"
              clearable
              :rules="f_required"
            />
          </v-card-text>
          <v-card-actions class="pt-6" v-if="selected.length !== 0">
            <v-spacer></v-spacer>
            <v-btn rounded color="warning" type="submit" :disabled="!price_valid">
              Aplicar cambio
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="edit_discount" max-width="400px">
      <v-form v-model="discount_valid" ref="discountChangeform" @submit="discount_change">
        <v-card>
          <v-toolbar dark color="secondary" flat dense>
            <h3>Descuento</h3>
            <v-spacer></v-spacer>
            <v-btn x-small fab color="orange" @click="edit_discount = !edit_discount">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-6" v-if="selected.length === 0">
            <h5>Debe seleccionar los productos a los que quiere cambiar el precio</h5>
          </v-card-text>
          <v-card-text class="pt-6" v-if="selected.length !== 0">
            <h3>El descuento será aplicado a {{ selected.length }} productos.</h3>
          </v-card-text>
          <v-card-text>
            <v-text-field
              mt="6"
              v-model="newPrice"
              class="centered-input"
              label="Descuento"
              solo
              prepend-inner-icon="mdi-currency-usd"
              clearable
              :rules="f_required"
            />
          </v-card-text>
          <v-card-actions class="pt-6" v-if="selected.length !== 0">
            <v-spacer></v-spacer>
            <v-btn rounded color="warning" type="submit" :disabled="!discount_valid">
              Aplicar descuento
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="price_changes_lst"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-card-title>
          <v-toolbar flat>
            <h3>Cambios de precio efectuados</h3>
            <v-spacer></v-spacer>
            <v-btn
              x-small
              fab
              color="orange"
              @click="price_changes_lst = !price_changes_lst"
            >
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="header_changes"
            :items="changes_lst"
            :items-per-page="10"
            class="elevation-4"
            :loading="loading_changes"
            loader-height="10"
            loading-text="Cargando ..."
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { webserver, getToday } from "../services/webserver.js";
import createItem from "../utils/createItem.js";

export default {
  components: {},
  data() {
    return {
      kpiData: {
        total_products: 0,
        total_categories: 0,
        total_value: 0,
        average_price: 0,
        total_units: 0,
        average_units: 0,
        discounted_products: 0,
        discount_percentage: 0,
      },
      showFilterPanel: false,
      filters: {
        nombre: "",
        categoria: null,
        marca: null,
        refe: "",
        precio: null,
        grupo: null,
        color: null,
        talla: null,
      },
      // Agregar arrays para los nuevos selectores
      grupos: [],
      colors: [],
      tallas: [], // Este array se puede llenar con las tallas disponibles
      errors: [],
      valid: false,
      item_dialogo: false,
      edit_price: false,
      edit_discount: false,
      price_valid: false,
      discount_valid: false,
      newPrice: 0,
      loading_status: false,
      f_required: [(v) => !!v || "Requerido"],
      f_email: [
        (v) => !!v || "Correo valido",
        (v) => /.+@.+/.test(v) || "Correo no valido",
      ],
      imageUrl: null,
      dialog: false,
      headers: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          filterable: true,
          value: "nombre",
          dataType: "text",
        },
        {
          text: "Categoría",
          align: "start",
          sortable: true,
          filterable: true,
          value: "categoria",
          dataType: "text",
        },
        {
          text: "Grupo",
          align: "start",
          sortable: true,
          filterable: true,
          value: "grupo",
          dataType: "text",
        },
        {
          text: "Marca",
          align: "start",
          sortable: true,
          filterable: true,
          value: "marca",
          dataType: "text",
        },
        {
          text: "Referencia",
          align: "start",
          sortable: true,
          filterable: true,
          value: "refe",
          dataType: "text",
        },
        {
          text: "Color",
          align: "start",
          sortable: true,
          filterable: true,
          value: "color",
          dataType: "text",
        },
        {
          text: "Tamaño",
          align: "start",
          sortable: true,
          filterable: true,
          value: "talla",
          dataType: "text",
        },
        {
          text: "Precio",
          align: "end",
          sortable: true,
          filterable: true,
          value: "precio",
          dataType: "number",
        },
        {
          text: "Descuento",
          align: "end",
          sortable: true,
          filterable: true,
          value: "descuento",
          dataType: "number",
        },
        {
          text: "Existencia",
          align: "end",
          sortable: true,
          filterable: true,
          value: "cantidad",
          dataType: "number",
        },
      ],
      header_changes: [
        {
          text: "Categoría",
          align: "start",
          sortable: true,
          filterable: true,
          value: "categoria",
          dataType: "text",
        },
        {
          text: "Grupo",
          align: "start",
          sortable: true,
          filterable: true,
          value: "grupo",
          dataType: "text",
        },
        {
          text: "Referencia",
          align: "start",
          sortable: true,
          filterable: true,
          value: "refe",
          dataType: "text",
        },
        {
          text: "Color",
          align: "start",
          sortable: true,
          filterable: true,
          value: "color",
          dataType: "text",
        },
        {
          text: "Tamaño",
          align: "center",
          sortable: true,
          filterable: true,
          value: "talla",
          dataType: "text",
        },
        {
          text: "Cantidad",
          align: "center",
          sortable: true,
          filterable: true,
          value: "quantity",
          dataType: "text",
        },
        {
          text: "Precio",
          align: "center",
          sortable: true,
          filterable: true,
          value: "price",
          dataType: "text",
        },
        {
          text: "Nuevo Precio",
          align: "center",
          sortable: true,
          filterable: true,
          value: "newPrice",
          dataType: "text",
        },
        {
          text: "Diferencia",
          align: "center",
          sortable: true,
          filterable: true,
          value: "diferencia",
          dataType: "text",
        },
      ],
      changes_lst: [],
      price_changes_lst: false,
      loading_changes: false,
      inventory_lst: [],
      inventory_filter: [],
      item: createItem(),
      selected: [],
      brands: [],
      categories: [],

      search: "",
      itemEdit: createItem(),
      compressed_image: null,
    };
  },
  mounted() {
    this.get_inventory();
    this.categories = Array.isArray(window.settings["CATEGORIA"])
      ? window.settings["CATEGORIA"].sort(this.GetSortOrder("valor"))
      : [];

    this.brands = Array.isArray(window.settings["MARCA"])
      ? window.settings["MARCA"].sort(this.GetSortOrder("valor"))
      : [];
  },
  methods: {
    selectAll() {
      this.selected = [...this.inventory_filter];
    },
    clearSelection() {
      this.selected = [];
    },
    printLabels() {
      if (!this.selected.length) {
        this.$store.commit("showMessage", {
          text: "Seleccione los productos para imprimir etiquetas",
          color: "warning",
        });
        return;
      }
      // Implementar la lógica de impresión
      console.log("Imprimir etiquetas para:", this.selected);
    },

    loadCatalog(catalogName) {
      return Array.isArray(window.settings[catalogName])
        ? window.settings[catalogName].sort(this.GetSortOrder("valor"))
        : [];
    },
    filterData() {
      const filter = this.filters;
      this.inventory_filter = this.inventory_lst.filter((item) => {
        return Object.keys(filter).every((key) => {
          // Si el filtro está vacío o es null, no aplicar este filtro
          if (filter[key] === null || filter[key] === "") return true;

          // Obtener el valor del item
          const itemValue = item[key]?.toString().toLowerCase();
          const filterValue = filter[key]?.toString().toLowerCase();

          // Si el valor del item no existe, no pasa el filtro
          if (!itemValue) return false;

          // Para precio, hacer comparación numérica
          if (key === "precio") {
            return parseFloat(itemValue) === parseFloat(filterValue);
          }

          // Para el resto, buscar coincidencia parcial
          return itemValue.includes(filterValue);
        });
      });
    },
    resetFilters() {
      this.filters = {
        nombre: "",
        categoria: null,
        marca: null,
        refe: "",
        precio: null,
        grupo: null,
        color: null,
        talla: null,
      };
      this.search = "";
      this.inventory_filter = this.inventory_lst;
    },
    formatCurrency(value) {
      if (!value && value !== 0) return "";
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);
    },
    get_inventory() {
      this.loading_status = true;
      var qry = {
        store: window.store.store_id,
        table: "items",
      };
      qry.filters = [
        {
          field: "id_pos",
          operator: "=",
          value: window.store.store_id,
        },
        {
          field: "cantidad",
          operator: ">",
          value: 0,
        },
      ];

      webserver("get_table", qry, (data) => {
        console.log(data);
        this.loading_status = false;
        this.inventory_lst = data;
        this.inventory_filter = data;

        // Calcular KPIs
        this.calculateKPIs(data);
      });
    },
    calculateKPIs(data) {
      if (!data || !Array.isArray(data)) return;

      // Total de productos únicos
      this.kpiData.total_products = data.length;

      // Total de categorías únicas
      this.kpiData.total_categories = new Set(data.map((item) => item.categoria)).size;

      // Calcular totales
      const totals = data.reduce(
        (acc, item) => {
          const precio = parseFloat(item.precio) || 0;
          const cantidad = parseFloat(item.cantidad) || 0;
          const value = precio * cantidad;

          return {
            value: acc.value + value,
            units: acc.units + cantidad,
            discounted: acc.discounted + (item.descuento > 0 ? 1 : 0),
          };
        },
        { value: 0, units: 0, discounted: 0 }
      );

      // Asignar valores calculados
      this.kpiData.total_value = totals.value;
      this.kpiData.total_units = totals.units;
      this.kpiData.average_price =
        this.kpiData.total_products > 0 ? totals.value / this.kpiData.total_products : 0;
      this.kpiData.average_units =
        this.kpiData.total_products > 0
          ? Math.round(totals.units / this.kpiData.total_products)
          : 0;
      this.kpiData.discounted_products = totals.discounted;
      this.kpiData.discount_percentage =
        this.kpiData.total_products > 0
          ? Math.round((totals.discounted / this.kpiData.total_products) * 100)
          : 0;
    },

    get_changes() {
      this.loading_changes = true;
      var qry = {
        store: window.store.store_id,
        issueDate: getToday(),
      };
      webserver("get_inventory_pc", qry, (data) => {
        console.log(data);
        data.forEach((itm) => {
          itm.diferencia = parseFloat(itm.diferencia);
          itm.price = parseFloat(itm.price);
          itm.quantity = parseFloat(itm.quantity);
          itm.newPrice = parseFloat(itm.newPrice);
        });
        this.loading_changes = false;
        this.changes_lst = data;
      });
    },
    GetSortOrder(prop) {
      return function (a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },
    getImageURL: function (marca, refe) {
      var account = window.store.store_id.substring(0, 6);
      var url =
        "https://moda-stc.com/photos/" + account + "/" + marca + "/" + refe + ".jpg";
      if (this.compressed_image) url = this.compressed_image;
      return url;
    },
    chooseImage() {
      this.$refs.fileInput.click();
    },
    onSelectFile(dat) {
      console.log(dat);
      const input = this.$refs.fileInput;
      const files = input.files;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          var img = new Image();
          img.onload = () => {
            var prct = 800 / img.width;
            const elem = document.createElement("canvas");
            elem.width = img.width * prct;
            elem.height = img.height * prct;
            const ctx = elem.getContext("2d");
            ctx.drawImage(img, 0, 0, img.width * prct, img.height * prct);
            var imageUrl = elem.toDataURL("image/jpeg");
            this.compressed_image = imageUrl;
            dat.picture = files[0].name;
            this.upload_photo(dat.marca, dat.refe.toLowerCase() + ".jpg", imageUrl);
            //this.$emit("compressed-image", imageUrl);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.item.picture = files[0].name.toLowerCase();

        //this.$emit("input", files[0].name.toLowerCase());
      }
    },
    upload_photo(marca, picture, data) {
      var qry = {
        store: window.store.store_id,
        photo: data,
        marca: marca,
        picture: picture,
      };

      webserver("upload_photo", qry, (data) => {
        console.log(data);
        this.compressed_image = null;
        //this.loading_status = false;
      });
    },

    editItem(data) {
      this.itemEdit = data;
      //console.log(data);
      this.item_dialogo = true;
    },
    checkFile(file) {
      if (!file) {
        return;
      }
      this.createImage(file);
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        var img = new Image();
        img.onload = function () {
          var prct = 800 / img.width;
          const elem = document.createElement("canvas");
          elem.width = img.width * prct;
          elem.height = img.height * prct;
          const ctx = elem.getContext("2d");
          ctx.drawImage(img, 0, 0, img.width * prct, img.height * prct);
          var imageUrl = elem.toDataURL("image/jpeg");
          console.log(imageUrl);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    newForm() {
      console.log(this.selected);
      //   this.supplier = createItem();
      //   this.valid = false;
      //   this.dialog = true;
    },
    exportJSONToCSV(objArray) {
      var arr = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
      var str =
        `${Object.keys(arr[0])
          .map((value) => `"${value}"`)
          .join(",")}` + "\r\n";
      var csvContent = arr.reduce((st, next) => {
        st +=
          `${Object.values(next)
            .map((value) => `"${value}"`)
            .join(",")}` + "\r\n";
        return st;
      }, str);
      var element = document.createElement("a");
      element.href = "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      element.target = "_blank";
      var current = new Date();
      var cDate =
        current.getFullYear() + "-" + (current.getMonth() + 1) + "-" + current.getDate();
      var cTime =
        current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
      var fileName = cDate + "_" + cTime;
      element.download = fileName + ".csv";
      element.click();
    },
    discount_change(e) {
      e.preventDefault();
      this.$refs.discountChangeform.validate();
      if (this.discount_valid) {
        var qry = {
          store: window.store.store_id,
          newprice: parseInt(this.newPrice),
          products: this.selected,
          userId: window.userId,
        };
        if (qry.newprice > 0) {
          console.log(qry);
          webserver("changeDiscount", qry, () => {
            this.get_inventory();
            this.edit_discount = false;
            //this.price_changes_lst = true;
          });
        }
      }
    },
    price_change(e) {
      e.preventDefault();
      this.$refs.priceChangeform.validate();
      if (this.price_valid) {
        var qry = {
          store: window.store.store_id,
          newprice: parseInt(this.newPrice),
          products: this.selected,
          userId: window.userId,
        };
        if (qry.newprice > 0) {
          console.log(qry);
          webserver("changePrice", qry, () => {
            this.get_inventory();
            this.edit_price = false;
            //this.price_changes_lst = true;
          });
        }
      }
    },
  },
  watch: {
    price_changes_lst(visible) {
      if (visible) {
        console.log(visible);
        this.get_changes();
        //this.setSku();
      }
    },
  },
};
</script>

<style>
.file-input {
  display: none;
}

.centered-input input {
  text-align: center;
}
.kpi-card {
  transition: all 0.3s;
}

.kpi-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Mejoras de responsividad */
@media (max-width: 600px) {
  .kpi-card {
    margin-bottom: 16px;
  }
}
/* Estilos para los filtros */
.v-card-title.primary {
  border-radius: 4px 4px 0 0;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-select.v-select--enclosed .v-select__details,
.v-autocomplete.v-autocomplete--enclosed .v-autocomplete__details {
  display: none;
}

/* Mejoras de responsividad para los filtros */
@media (max-width: 600px) {
  .v-card-title {
    flex-wrap: wrap;
  }

  .v-card-title .v-text-field {
    margin-top: 8px;
    max-width: 100% !important;
  }
}
.option-card {
  transition: all 0.3s;
  height: 100%;
}

.option-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.v-btn.justify-start {
  justify-content: flex-start;
}

.v-btn.justify-start .v-icon {
  margin-right: 8px;
}

.secondary {
  background-color: #3949ab !important;
}

/* Mejoras de responsividad */
@media (max-width: 960px) {
  .option-card {
    margin-bottom: 16px;
  }
}
.v-menu__content {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.v-list-item {
  min-height: 40px !important;
}

.v-list-item__icon {
  margin: 12px 0 !important;
}

.v-subheader {
  font-size: 0.875rem;
  font-weight: 500;
  height: 36px;
  padding: 0 16px;
}

/* Ajustes responsivos */
@media (max-width: 600px) {
  .v-toolbar-title {
    font-size: 1.1rem;
  }
}
</style>
